import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '../../Global/Icons/Icon';

const MainMenuSubmenuItem = ({ title, href, active, iconName, description }) => {
  const linkClass = classnames('main-menu-submenu__link card-link d-flex flex-column align-items-center text-center', {
    'main-menu-submenu__link--active': active,
  });

  return (
    <li className="main-menu-submenu__item col-md-4">
      <a href={href} className={linkClass}>
        <div className="card-link__text-change">
          <Icon name={iconName} size="m" />
          <span className="like-p fw-medium d-block m-b-0">{title}</span>
        </div>
        <p className="color-grey m-b-0">{description}</p>
      </a>
    </li>
  );
};

MainMenuSubmenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  active: PropTypes.bool,
  iconName: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default MainMenuSubmenuItem;



// WEBPACK FOOTER //
// ./library/app/components/Global/Menus/MainMenuSubmenuItem.js